<template>
  <WsVersion
    localeMode
    hasExpandList
    label="法規"
    titleKey="last_version.name"
    :subList="_subList"
    :id="$route.params.id"
    :modelName="modelName"
    :fields="versionFields"
    :showFields="showFields"
    :customBtns="_customBtns"
    :versionModelName="versionModelName"
    :versionTimestampKey="versionTimestampKey"
    :editable="!_isIdtfIdentifying"
    :deletable="!_isIdtfIdentifying"
    @input="$_getModelData"
    @go-to-related-template="$_onGoToRelatedTemplate"
    @unbind-item-from-parent="$_onUnbindItemFromParent($event)"
  />
</template>

<script>
import model from '@/models/act';
import submodel from '@/models/article';

export default {
  data() {
    return {
      modelName: model.modelName,
      versionModelName: model.versionModelName,
      versionFields: model.fields.last_version.fields,
      versionTimestampKey: model.versionTimestampKey,
      showFields: [
        'updated_at',
        'locales',
        'announce_at',
        'effect_at',
        'reference_link',
      ],
      subList: {
        type: 'expandList',
        label: submodel.label,
        modelName: submodel.versionModelName,
        modeParent: true,
        modeVersions: true,
        modeParentVersions: true,
        fields: submodel.fields.last_version.fields,
        titleKey: 'no_text',
        fieldsRead: [
          'locales',
          'announce_at',
          'effect_at',
          'attaches',
          'effects',
        ],
        searchMode: false,
        orderBy: 'no_number',
        orderWay: 'asc',
        hideOnNull: false,
        fetchWithParams: true,
        isVersionAPI: true,
        itemDeletable: false,
        itemVersionReadable: true,
        itemCreatable: false,
        itemVersionReadableUrl: function (modelData) {
          return `/article/${modelData.article.id}/version`;
        },
        batchLink: function (data) {
          return `/act_version/${data.version_id}/article/create/batch`;
        },
      },
      modelData: null,
    };
  },
  computed: {
    _customBtns() {
      return [
        {
          title: '相關連動公版',
          color: 'textSecondary',
          outlined: true,
          icon: 'mdi-view-dashboard',
          emit: 'go-to-related-template',
        },
      ];
    },
    _isIdtfIdentifying(){
      if (!this.modelData) return false;
      return this.modelData.last_version.act_idtf_status === 'identifying';
    },
    _subList() {
      return {
        ...this.subList,
        itemEditable: !this._isIdtfIdentifying,
      };
    }
  },
  methods:{
    $_onGoToRelatedTemplate(versionId){
      this.$router.push(
        `/${this.modelName}/${this.$route.params.id}/relatedtemplate/${versionId.versionId}`
      );
    },
     async $_onUnbindItemFromParent($event){
      try {
        const act_versions = { act_versions: [$event.parentId]}
        await this.$axios.post(`/article_version/${$event.itemId}/remove`, act_versions);
      } catch(error) {
        alert(error)
      }
    },
    $_getModelData(modelData){
      this.modelData = modelData;
    }
  }
};
</script>